module.exports = __webpack_public_path__ + "f6366750df49ae4cec01e3f31db83c9d.png";